import { Icon } from "@iconify/react";
import { Link, type LinkProps } from "react-router";

interface ButtonLinkIconProps extends LinkProps {
  icon: string;
  spin?: boolean;
}

export default function ButtonLinkIcon({
  className,
  icon,
  spin,
  ...res
}: ButtonLinkIconProps) {
  return (
    <Link
      {...res}
      className={`${className} w-11 cursor-pointer duration-150 hover:scale-110 hover:bg-current/10! flex-center text-2xl! h-11 rounded-full`}
    >
      <Icon
        icon={icon}
        className={`${
          spin ? "animate-spin [animation-duration:12s]" : ""
        } text-current!`}
      />
    </Link>
  );
}
